
import React, { useState } from 'react';

interface Image {
  url: string;
  type: 'image' | 'video';
}

interface TocFotosGalleryProps {
  title: string;
  description: string;
  images: Image[];
}

const TocFotosGallery: React.FC<TocFotosGalleryProps> = ({ title, description, images }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  
  return (
    <section className="bg-[#333333] py-10 md:py-16 relative">
      <div className="container mx-auto px-4">
        <h2 className="text-white text-center text-3xl md:text-4xl font-bold mb-8">{title}</h2>
        <p className="text-gray-300 text-center max-w-3xl mx-auto mb-10">{description}</p>
        
        {/* Main Image */}
        <div className="relative bg-[#333333] rounded-lg shadow-lg overflow-hidden aspect-w-16 aspect-h-9 mb-4">
          {images[activeIndex].type === 'image' ? (
            <img 
              src={images[activeIndex].url} 
              alt={`Gallery image ${activeIndex + 1}`} 
              className="w-full h-full object-contain"
            />
          ) : (
            <video 
              src={images[activeIndex].url} 
              controls 
              className="w-full h-full object-contain"
            />
          )}
        </div>
        
        {/* Thumbnails */}
        <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2 mt-6">
          {images.map((img, index) => (
            <div 
              key={index} 
              onClick={() => setActiveIndex(index)}
              className={`cursor-pointer rounded overflow-hidden aspect-square relative ${
                activeIndex === index ? 'ring-2 ring-toctoc-blue' : 'opacity-70 hover:opacity-100'
              }`}
            >
              {img.type === 'image' ? (
                <img 
                  src={img.url} 
                  alt={`Thumbnail ${index + 1}`} 
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="relative w-full h-full bg-gray-800">
                  <video 
                    src={img.url}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z"/>
                    </svg>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TocFotosGallery;
